








import { Component, Vue, Watch } from 'vue-property-decorator'
import Layout from '../components/Layout.vue'
import { markdown } from '../constant'

@Component({
  components: {
    Layout,
    ...markdown
  }
})
export default class Home extends Vue {
  current: string = ''

  @Watch('$route.path')
  onPathChange (val: string) {
    this.pathChange(val.substring(1))
  }

  created () {
    this.pathChange()
  }

  pathChange (name: string = this.$route.path.substring(1)) {
    this.current = name[0].toUpperCase() + name.substring(1)
  }
}
